import {
  CCRC_WIDGET_TYPES,
  PUBLIC_DATA_WIDGET_TYPES,
  RENTAL_WIDGET_TYPES,
  SALES_BATTLECARD_WIDGET_TYPES,
} from 'common/Widgets/constants';
import { COMMUNITY_RENTAL_TYPE } from 'constants/rentalTypes';
import { CommunityRentalType } from 'types/contracts';

type GetAvailableWidgetOptionsArgs = {
  graphOptions: number[];
  singleOptions: number[];
  showPricingData: boolean;
  associatedRentalTypes?: CommunityRentalType[];
};

export const getAvailableWidgetOptions = ({
  graphOptions,
  singleOptions,
  showPricingData,
  associatedRentalTypes,
}: GetAvailableWidgetOptionsArgs) => {
  let availableGraphOptions = [...graphOptions];
  let availableSingleOptions = [...singleOptions];

  if (!showPricingData) {
    availableGraphOptions = availableGraphOptions.filter((type) => PUBLIC_DATA_WIDGET_TYPES.includes(type));
    availableSingleOptions = [];
  }

  if (associatedRentalTypes?.length === 2) {
    const isBothWidgetType = (type: number) =>
      (CCRC_WIDGET_TYPES.includes(type) || RENTAL_WIDGET_TYPES.includes(type)) &&
      !SALES_BATTLECARD_WIDGET_TYPES.includes(type);

    availableGraphOptions = availableGraphOptions.filter(isBothWidgetType);
    availableSingleOptions = availableSingleOptions.filter(isBothWidgetType);
  } else if (associatedRentalTypes?.some((viewRentalType) => viewRentalType.type === COMMUNITY_RENTAL_TYPE.CCRC)) {
    availableGraphOptions = availableGraphOptions.filter((type) => CCRC_WIDGET_TYPES.includes(type));
    availableSingleOptions = availableSingleOptions.filter((type) => CCRC_WIDGET_TYPES.includes(type));
  } else if (associatedRentalTypes?.some((viewRentalType) => viewRentalType.type === COMMUNITY_RENTAL_TYPE.RENTAL)) {
    availableGraphOptions = availableGraphOptions.filter((type) => RENTAL_WIDGET_TYPES.includes(type));
    availableSingleOptions = availableSingleOptions.filter((type) => RENTAL_WIDGET_TYPES.includes(type));
  }

  return {
    availableGraphOptions,
    availableSingleOptions,
  };
};
